import * as React from "react"

const Paperclip = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 18 18"
    fill="none"
    // EGDE-224: keep overflow visible so the clip's top loop never gets shaved
    // by the SVG's default overflow:hidden.
    overflow="visible"
    {...props}
  >
    {/* EGDE-224: attachment paperclip geometry exported from the Figma upload
        field. The previous hand-authored Lucide path was a horizontal mirror of
        the design (clip leaning the wrong way); this matches it exactly. */}
    <path
      d="M14.2184 8.91559L8.62042 14.5135C7.15596 15.978 4.78159 15.978 3.31712 14.5135C1.85266 13.0491 1.85266 10.6747 3.31712 9.21022L10.0936 2.43378C11.0699 1.45747 12.6528 1.45747 13.6291 2.43378C14.6054 3.41009 14.6054 4.99301 13.6291 5.96932L6.76848 12.8299C6.28032 13.3181 5.48886 13.3181 5.00071 12.8299C4.51255 12.3418 4.51255 11.5503 5.00071 11.0622L10.6828 5.38006"
      stroke="currentColor"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Paperclip
